import { assertSortParam } from './internal/assertSortParam';

export function ensureSortParam(name: unknown) {
  assertSortParam(name);
  return name;
}
